<template>
  <section class="Users">
    <table-users></table-users>
  </section>
</template>
<script>
import tableUsers from "@/components/common/table-users.vue";
export default {
  components: { tableUsers }
};
</script>
